import React from 'react';
import PropTypes from 'prop-types';
import { withStyles, TableContainer, Table, TableBody } from "@material-ui/core";
import TableHeader from './../../Common/TableHeader';
import t from "../../../languages/pl";
import { notArrayOrEmpty } from '../../../utils/helpers';
import NoData from './../../Common/NoDataRow';
import InfiniteScroll from '../../Common/InfiniteScroll';
import ClientRow from './ClientRow';

const useStyles = theme => ({
    cell: {
        textAlign: "center",
        padding: 0
    },
    table: {
        marginTop: theme.spacing(1),
        height: "69vh"
    }
});


const header = [t.clientsName, t.type2, t.address, "NIP", t.manage];

const ClientsTable = props => {
    const { classes, clients, onClientsManageClick } = props;

    const printTable = data => {
        if (notArrayOrEmpty(data))
            return <NoData colSpan={5} />;
            return (
                    <InfiniteScroll
                        initialCount={10}
                        colSpan={10}
                        elements={clients}
                        RowComponent={ClientRow}
                        classes={classes}
                        onClientsManageClick={onClientsManageClick}
                    />
            );
    };

    return (
        <TableContainer className={classes.table}>
            <Table stickyHeader>
                <TableHeader data={header} />
                <TableBody>
                    {printTable(clients)}
                </TableBody>
            </Table>
        </TableContainer>
    );
};

ClientsTable.propTypes = {
    classes: PropTypes.object,
    clients: PropTypes.array,
    onClientsManageClick: PropTypes.func
};

export default withStyles(useStyles)(ClientsTable);
